import { Component, OnInit, Injector, Input } from '@angular/core';

import { bitfToTranslate } from '@common/libs/bitforce/utils/bitf-translate.utils';

import { EBitfCloseEventStatus, EFsContentType, EFsType } from '@enums';
import { IBitfCloseEvent, IBitfOkCancelDialogDataPrompt } from '@interfaces';
import { CONSTANTS } from '@constants';
import { FsCreateItemComponent } from '../fs-create-item/fs-create-item.component';

@Component({
  selector: 'prada-fs-create-folder-button',
  templateUrl: './fs-create-folder-button.component.html',
  styleUrls: ['./fs-create-folder-button.component.scss'],
})
export class FsCreateFolderButtonComponent extends FsCreateItemComponent implements OnInit {
  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onCreateFolder() {
    const ref = this.dialogService.dialog.open(CONSTANTS.okCancelDialogComponent, {
      width: '90%',
      maxWidth: '400px',
      height: 'auto',
      maxHeight: '500px',
      data: {
        title: bitfToTranslate('COMMON.DIALOG.CREATE_FOLDER.TITLE'),
        prompt: {
          label: bitfToTranslate('COMMON.DIALOG.CREATE_FOLDER.FOLDER_NAME'),
          isRequired: true,
        },
        cancelText: bitfToTranslate('BITF.LABEL.CANCEL'),
        okText: bitfToTranslate('BITF.LABEL.CREATE'),
      },
    });
    ref.afterClosed().subscribe((result: IBitfCloseEvent<IBitfOkCancelDialogDataPrompt>) => {
      if (result && result.status === EBitfCloseEventStatus.OK) {
        this.loaderService.show();
        this.fsService
          .useFs(this.fsStore)
          .postRel({
            id: this.fsStore.currentItem.id,
            body: {
              name: result.data.value,
              contentType: this.fsStore.configuration.uploadBodyRequest.contentType,
              isFolder: 1,
            },
            isBodyRaw: true,
          })
          .subscribe(() => {
            this.apiCallStateService.setStore(() => {
              this.setCreatedSortDesc();
            }, this.apiCallStateName);
          });
      }
    });
  }
}
